import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faTimes } from '@fortawesome/free-solid-svg-icons';
import styles from './SearchInput.module.scss';

export const SearchInput = ({ 
    placeholder = "Search by queue number...", 
    value = "", 
    onChange, 
    onClear,
    className = "",
    disabled = false 
}) => {
    const [isFocused, setIsFocused] = useState(false);

    const handleInputChange = (e) => {
        if (onChange) {
            onChange(e.target.value);
        }
    };

    const handleClear = () => {
        if (onClear) {
            onClear();
        }
    };

    const handleFocus = () => {
        setIsFocused(true);
    };

    const handleBlur = () => {
        setIsFocused(false);
    };

    return (
        <div className={`${styles['search-input-container']} ${className} ${isFocused ? styles['focused'] : ''}`}>
            <div className={styles['search-input-wrapper']}>
                <FontAwesomeIcon 
                    icon={faSearch} 
                    className={styles['search-icon']} 
                />
                <input
                    type="text"
                    value={value}
                    onChange={handleInputChange}
                    onFocus={handleFocus}
                    onBlur={handleBlur}
                    placeholder={placeholder}
                    className={styles['search-input']}
                    disabled={disabled}
                />
                {value && (
                    <button
                        type="button"
                        onClick={handleClear}
                        className={styles['clear-button']}
                        aria-label="Clear search"
                    >
                        <FontAwesomeIcon icon={faTimes} />
                    </button>
                )}
            </div>
        </div>
    );
};
